"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var clone = require('clone');
var tv4 = require('tv4');
var PersonReference = require('../core/person-reference');
var Audit = /*#__PURE__*/function () {
  function Audit(opt) {
    _classCallCheck(this, Audit);
    this.type = null;
    this.rule = null;
    this.message = null;
    this.actionMessage = null;
    this.field = null;
    this.value = null;
    this.fieldType = null;
    this.ignoreBy = null;
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Audit, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.type = opt.type;
      this.rule = opt.rule;
      this.message = opt.message;
      this.actionMessage = opt.actionMessage;
      this.field = opt.field;
      this.value = opt.value;
      this.fieldType = opt.fieldType;
      this.ignoreBy = opt.ignoreBy ? new PersonReference(opt.ignoreBy) : null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Audit.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'audit.schema.json',
        type: 'object',
        properties: {
          type: {
            type: ['string', 'null']
          },
          rule: {
            type: ['string', 'null']
          },
          message: {
            type: ['string', 'null']
          },
          actionMessage: {
            type: ['string', 'null']
          },
          field: {
            type: ['string', 'null']
          },
          value: {
            type: ['string', 'null']
          },
          fieldType: {
            type: ['string', 'null']
          },
          ignoreBy: {
            $ref: 'person-reference.schema.json'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return Audit;
}();
tv4.addSchema(PersonReference.schema());
module.exports = Audit;